import React from 'react'
import classNames from 'classnames'
import styles from './FormError.module.css'

export default function FormError({ children, className }) {
  return <div className={classNames(styles.error, className)}>{children}</div>
}
